<app-loading [show]="loading"></app-loading>
@if (!loading) {
<div>
  <p>Resumo dos ganhos:</p>
  <section class="grid grid-cols-2 justify-center">
    <div>
      <app-select-button
        [selectedOption]="selectedRange"
        (selectedOptionChange)="onRangeChange($event)"
      ></app-select-button>
      <app-line-chart [chartOptions]="lineChartOptions"></app-line-chart>
    </div>

    <div class="grid grid-cols-2 p-4 content-evenly">
      <app-card class="col-span-2">
        <h1>Vendas Líquidas</h1>
        <strong class="text-2xl">{{ formatterValue(valor) }}</strong>
      </app-card>

      <div>
        <h3>Pedidos pagos</h3>
        <strong>{{ pedidosPagos }}</strong>
      </div>

      <div>
        <h3>Média pedido</h3>
        <strong>{{ mediaPedidos }}</strong>
      </div>
    </div>
  </section>
  <hr class="text-gray-300 h-2" />
  <h2 class="text-xl font-bold">Outras atividades:</h2>
  <section class="grid grid-cols-2">
    <div class="flex space-x-6 p-4">
      <div>
        <h3>Descontos</h3>
        <strong class="text-2xl">R$0.00</strong>
      </div>
      <div>
        <h3>Reembolso</h3>
        <strong class="text-2xl">R$0.00</strong>
      </div>
    </div>

    <div>
      <app-bar-chart [chartOptions]="barChartOptions"></app-bar-chart>
    </div>
  </section>
</div>
}
